import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateInstitutionSchool = (props) => {
  const baseRecord = {
    institution_id: props.params.institutionId
  }
  return (
    <Create
// @ts-ignore
      title='Add School or College to Institution'
      fields={fields}
      resource={baseRecord}
      apiPath='admin/institution_schools'
      successRedirectPath={resource => `/membership/institutions/${resource.institution_id}/schools`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateInstitutionSchool
